export const LUXURY_ESCAPES = 'luxuryescapes'
export const CUDO_TRAVEL = 'cudotravel'
export const DEALS_TRAVEL = 'dealstravel'
export const SCOOPON_TRAVEL = 'scoopontravel'
export const TREATME_TRAVEL = 'treatmetravel'
export const LE_AGENT_HUB = 'leagenthub'
export const LE_AGENT_HUB_CVFR = 'leagenthub_cvfr'
